module.exports = __webpack_public_path__ + "img/secondHand1_mobile_en.9de4a970.png";